import type { KeycloakConfig } from "keycloak-js";

export const keycloakConfig: KeycloakConfig = {
    url: import.meta.env.VITE_IDP_ENDPOINT,
    realm: import.meta.env.VITE_IDP_REALM,
    clientId: import.meta.env.VITE_IDP_CLIENT_ID,
    //KeycloakResponseType: 'code'
}

export const API_BASE_URL = import.meta.env.VITE_API_ENDPOINT;